import { getTopElement } from "qpr-base/api/model";
import { useAppContext } from "qpr-base/context/AppCtxProvider";

import { useQuery } from "react-query";
import useTopElements from "./useTopElements";

const useTopElement = (scorecardSymbol: string, attributes: string) => {
  const ctx = useAppContext();

  const { data: topElems, isLoading: topElementsLoading } = useTopElements();

  // If top element of root scorecard is queried, check that user has at least view rights.
  // If not, return first top element that user has rights to
  if (scorecardSymbol === "L0") {
    const rootSC = topElems?.find((el) => el.scorecardsymbol === "L0");
    if (rootSC?.accesslevel === "-1")
      scorecardSymbol =
        topElems?.find((el) => el.accesslevel !== "-1")?.scorecardsymbol || "";
  }

  return useQuery(
    `scorecard-${scorecardSymbol}-${JSON.stringify(attributes)}`,
    async () => {
      const result = await getTopElement(
        ctx.modelId,
        scorecardSymbol,
        attributes
      );
      return result[0];
    },
    { cacheTime: 10 * 60 * 1000, staleTime: 10 * 60 * 1000 }
  );
};

export default useTopElement;
